// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__R0L76","section__inner":"section_section__inner__4ZahS","section--full-bleed":"section_section--full-bleed__Epi3D"};